"use client";

import SharedBriefingApp from "@app/toolkit/_shared/components/BriefingApp";
import BriefingForm from "./BriefingForm";
import { POTENTIAL_CONFIG } from "../config";
import type { BriefingData } from "../types";

/** Client boundary: binds the shared engine to this page's config and form. */
export default function BriefingApp({ data }: { data: BriefingData }) {
  return <SharedBriefingApp data={data} config={POTENTIAL_CONFIG} FormComponent={BriefingForm} />;
}
